export default "__VITE_ASSET__Cvn01UWd__"